import { render, staticRenderFns } from "./CourseListTable.vue?vue&type=template&id=ab071e1c&scoped=true&"
import script from "./CourseListTable.vue?vue&type=script&lang=js&"
export * from "./CourseListTable.vue?vue&type=script&lang=js&"
import style0 from "./CourseListTable.vue?vue&type=style&index=0&id=ab071e1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab071e1c",
  null
  
)

export default component.exports